export const MODULE_NAME = 'canonicalLink';

// used to target <link id='CANONICAL_LINK_ID' rel='canonical .../>
// in querySelector
export const CANONICAL_LINK_ID = 'vsx-canonical-link';
